import { http } from '@frontend/fetch';
import { useTranslation } from '@frontend/i18n';
import { useAlert } from '@frontend/design-system';
import { useMerchants } from './merchants';

// allLocations should be true when information is needed for a location that is not selected in the location filter
type UseStripeDashboardLinkOptions = {
  locationIds: (string | undefined)[];
};

export interface PaymentProcessorResponse {
  activated: boolean;
  id: string;
  links: {
    connectionToken: null;
    dashboard: string | null;
    location: string;
    paymentLocation: string;
    paymentMethods?: string;
    paymentRequest: string;
    paymentTerminal?: string;
  };
  locationId: string;
  stripeUserId: string;
  terminal: {
    locationId: string;
  };
}

export type PaymentProcessorDataResponse = {
  data: PaymentProcessorResponse;
};
export const useStripeDashboardLink = ({ locationIds }: UseStripeDashboardLinkOptions) => {
  const alert = useAlert();
  const t = useTranslation('payments').t;
  const { merchantsData } = useMerchants(locationIds);

  return (locationId: string) => async (e: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => {
    e.preventDefault();
    const merchantData = merchantsData[locationId];
    const activeProcessor = merchantData?.activeProcessor;

    if (activeProcessor) {
      try {
        const { data } = await http.get<PaymentProcessorDataResponse>(`payments/processors/${activeProcessor.id}`);
        if (data.links.dashboard) {
          window.open(data.links.dashboard, '_blank');
        } else {
          alert.error(t('Payment Admin role is required'));
        }
      } catch {
        alert.error(t('Error getting dashboard link'));
      }
    }
  };
};
